import React, { Component } from "react";
import {
  withStyles,
  CircularProgress,
  MenuItem,
  Button,
} from "@material-ui/core";
import CreateNewFolderIcon from "@material-ui/icons/CreateNewFolder";
import clsx from "clsx";
import {
  __getMessageId,
  __getNotes,
  __getStatus,
  __getTrackStatusByID,
  __setStatus,
} from "../../utils/utils";
import { connect } from "react-redux";
import { _PermittedContent } from "../../../_module/utils/PermittedContent";
import { styles } from "../ClearanceForm.css";
import {
  loadcfWithClerance,
  getCFContent,
  openWizard,
  getCFTrackMetadata,
} from "../../../redux/actions/MlLicFormContentActions";
import { __updateCfStatus } from "../../../modules/ml-licensing/clearance-form/Utils";
import { withRouter } from "react-router-dom";
import { loadRuntime } from "../../../redux/actions/ClearanceRuntimeActions";
// import moment from "moment";
import { PlaylistItemTypes } from "./../../../modules/ml-music-search/track/RecentPlaylistMenu";
// import { makeRandomId } from "../../../util/CommonFunc";
import newCf from "../../utils/newCF";
import { canCreateClearanceForms, canEditClearanceForms } from "util/CommonFunc";
import { v4 as uuidv4 } from "uuid";

class ClearanceButton extends Component {
  canRunCFWizard = false;
  constructor(props) {
    super();
    this.state = {
      loading: false,
      errors: null,
    };

    const { fromCfId, fromCF, fromCfBy,} = props;


     if(fromCfId || fromCF){
      this.canRunCFWizard = canEditClearanceForms(fromCfBy);
    }else{
      this.canRunCFWizard = canCreateClearanceForms();
     }
    

  }

  componentDidMount() {
    const {
      runtime: { loading, errors, runtime },
      loadRuntime,
    } = this.props;

    if (!loading && !runtime && !errors) {
      loadRuntime(null);
    }
  }

  _newCf = (selectedItems, items, trackSequence) => {
    const { 
      user,
      runtime: { runtime },
  } = this.props;
    return newCf(user,selectedItems, items, runtime, trackSequence);
  };

  getCF = async () => {
    const { selectedItems, items, fromCfId, loadingCall, loadingCallParam } =
      this.props;
      if (fromCfId) {
      this.setState({ loading: true, errors: null });
      return getCFContent(fromCfId, (data) => {
        return data;
      });
    } else if (loadingCall && loadingCallParam) {
      this.setState({ loading: true, errors: null });
      return loadingCall(loadingCallParam).then((v) => {
        const trackIds = [];
        const cleanedTracks = [];
        let trackSequence = {};
        const tracks = v?.filter(
          (r) => !r.pl_prop_type || r.pl_prop_type === PlaylistItemTypes.track
        );
        if (tracks) {
          tracks.forEach((t) => {
            let sequenceId = uuidv4();
            const trackCopy = JSON.parse(JSON.stringify(t));
            trackCopy.pl_prop_id = undefined;
            trackCopy.pl_prop_type = undefined;
            trackCopy.pl_prop_position = undefined;
            trackCopy.pl_prop_notes = undefined;
            trackCopy.pl_prop_tags = undefined;
            trackCopy.highlights = undefined;
            trackCopy.skyMlId = t.id;
            trackCopy.id = sequenceId;
            cleanedTracks.push(trackCopy);
            trackIds.push(sequenceId);
            trackSequence[sequenceId] = t.id; 
          });
        }
        return this._newCf(trackIds, cleanedTracks, trackSequence);
      });
    } else {
      const trackIds = [];
      const cleanedTracks = [];
      let trackSequence = {};
      const tracks = items?.filter(
        (r) => !r.pl_prop_type || r.pl_prop_type === PlaylistItemTypes.track
      );
      if (tracks) {
        tracks.forEach((t) => {
          let sequenceId = uuidv4();
          if (selectedItems?.includes(t.id)){
            trackIds.push(sequenceId);
            trackSequence[sequenceId] = t.id;
          }
          const trackCopy = JSON.parse(JSON.stringify(t));
          trackCopy.pl_prop_id = undefined;
          trackCopy.pl_prop_type = undefined;
          trackCopy.pl_prop_position = undefined;
          trackCopy.pl_prop_notes = undefined;
          trackCopy.pl_prop_tags = undefined;
          trackCopy.highlights = undefined;
          trackCopy.skyMlId = t.id;
          trackCopy.id = sequenceId;

          cleanedTracks.push(trackCopy);
        });
      }
      return this._newCf(trackIds, cleanedTracks, trackSequence);
    }
  };

  loadClearanceTrackMetadata = (trackIds)=>{
    const { getCFTrackMetadata } = this.props;
    return new Promise((resolve, reject) => {
      getCFTrackMetadata(trackIds, (data, error)=>{
        if(data){
          resolve(data);
        }
      });
    })
  }

  handleOpen = async (e) => {
    const { propogateClose, fromCF, liveCopy, history :{ location } } = this.props;

    if (fromCF) {
      const { openWizard, selectedItems, propogateClose } = this.props;
      if (propogateClose) propogateClose();
      await this.loadClearanceTrackMetadata(selectedItems);
      openWizard({ ids: selectedItems, copyLive: liveCopy || false });
    } else {
      this.getCF().then((cf) => {
        if (cf) {
          this.setState({ loading: false, errors: null });
          if (propogateClose) propogateClose();
          const { loadcfWithClerance } = this.props;
          loadcfWithClerance(
            {
              ...cf,
              wizard: {
                ids: cf?.clearance?.tracks || [],
                copyLive: liveCopy || false,
              },
            },
            async () => {
              await this.loadClearanceTrackMetadata(cf?.clearance?.tracks);
              this.props.history.push(
                "/mllicensingforms/" + (cf.id ? cf.id : "_"),
                { from: location.pathname }
              );
            }
          );
        } else {
          this.setState({ loading: false, errors: { e: "Error" } });
        }
      });
    }
  };

  render() {
    const {
      label,
      varient,
      varientClass,
      classes,
      wrapperClass,
      disableRipple,
      hideCount,
      hideIcon,
      loadingCall,
      count,
      fromCfId,
      selectedItems,
      liveCopy,
      id,
      liveCopyDisabled,
      runtime: { loading: runtimeLoding, errors: runtimeErrors },
      disableRunClearance
    } = this.props;

    const { loading, errors } = this.state;

    return (this.canRunCFWizard &&
      <>
        {varient && varient === "inline" ? (
          <Button
            className={varientClass}
            disabled={
              (liveCopy && liveCopyDisabled) ||
              !this.canRunCFWizard ||
              runtimeLoding ||
              runtimeErrors ||
              loading ||
              errors ||
              (!fromCfId &&
                !loadingCall &&
                (!selectedItems || !selectedItems.length))
                ? true
                : false
            }
            onClick={this.handleOpen}
          >
            {label || "Clear Me"}
            {(loading || runtimeLoding) && (
              <CircularProgress className={classes.insideLoader} />
            )}
            {(errors || runtimeErrors) && <span>{" Error"}</span>}
          </Button>
        ) : (
          <MenuItem
          id={`run-clearance-${id}`}
            disableRipple={disableRipple ? true : false}
            disabled={
              count < 1 ||
              (liveCopy && liveCopyDisabled) ||
              !this.canRunCFWizard ||
              runtimeLoding ||
              runtimeErrors ||
              loading ||
              errors ||
              disableRunClearance || 
              (!fromCfId &&
                !loadingCall &&
                (!selectedItems || !selectedItems.length))
                ? true
                : false
            }
            className={clsx(
              !wrapperClass && [classes.addtoClearanceButton], 
              liveCopy && [classes.runLiveClearance],
              wrapperClass && classes[wrapperClass]
                ? classes[wrapperClass]
                : classes.buttonSquare
            )}
            onClick={this.handleOpen}
          >
            {!hideIcon && (
              <CreateNewFolderIcon className={classes.actionMenuIcon} />
            )}
            {label
              ? label
              : liveCopy
              ? "Run Clearance (Live Version)"
              : "Run Clearance "}
            {!hideCount && <>({count || selectedItems.length})</>}
            {(loading || runtimeLoding) && (
              <CircularProgress className={classes.insideLoader} />
            )}
            {(errors || runtimeErrors) && <span>{" Error"}</span>}
          </MenuItem>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  runtime: state.clearanceRuntime,
  user: state.user,
});

export default connect(mapStateToProps, {
  loadcfWithClerance,
  openWizard,
  loadRuntime,
  getCFTrackMetadata, 
})(withStyles(styles)(withRouter(ClearanceButton)));
